// extracted by mini-css-extract-plugin
module.exports = {"main":"Dialog_main__vN7lz","x":"Dialog_x__jA_d7"};